module.exports = __webpack_public_path__ + "img/360-multiop 2.2704a837.jpg";